export default "__VITE_ASSET__Rfmx6Hfh__"